import { c as _c } from "react/compiler-runtime";
import { postEntitiesByFpIdTokenMutation } from '@onefootprint/fetch-dashboard';
import { useRequestErrorToast } from '@onefootprint/hooks';
import type { ContactInfoKind, TokenOperationKind } from '@onefootprint/request-types/dashboard';
import { useToast } from '@onefootprint/ui';
import { useMutation } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
type SendLinkMutationProps = {
  kind: TokenOperationKind;
  sendTo: ContactInfoKind;
  onDone: () => void;
};
const useSendTokenLinkMutation = entityId => {
  const $ = _c(11);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "actions.sendLink"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  const showRequestErrorToast = useRequestErrorToast();
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = postEntitiesByFpIdTokenMutation();
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const generateTokenMutation = useMutation(t1);
  const {
    toast
  } = useToast();
  const {
    isPending
  } = generateTokenMutation;
  let t2;
  if ($[2] !== entityId || $[3] !== generateTokenMutation || $[4] !== showRequestErrorToast || $[5] !== t || $[6] !== toast) {
    t2 = t3 => {
      const {
        kind,
        sendTo,
        onDone
      } = t3;
      generateTokenMutation.mutate({
        body: {
          kind,
          sendLinkTo: [sendTo]
        },
        path: {
          fpId: entityId
        }
      }, {
        onSuccess: response => {
          toast({
            title: t(_temp),
            description: t($_0 => $_0.description[response.deliveryMethods[0]])
          });
          onDone();
        },
        onError: error => {
          showRequestErrorToast(error);
          onDone();
        }
      });
    };
    $[2] = entityId;
    $[3] = generateTokenMutation;
    $[4] = showRequestErrorToast;
    $[5] = t;
    $[6] = toast;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const mutate = t2;
  let t3;
  if ($[8] !== isPending || $[9] !== mutate) {
    t3 = {
      mutate,
      isPending
    };
    $[8] = isPending;
    $[9] = mutate;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};
export default useSendTokenLinkMutation;
function _temp($) {
  return $.header;
}